/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'

interface Dimensions {
    height: number
    width: number
}

export function useDimensions(deductions?: Partial<Dimensions>): Dimensions {
    const [dimensions, setDimensions] = useState({
        height: window.innerHeight - (deductions?.height ?? 0),
        width: window.innerWidth - (deductions?.width ?? 0)
    })

    useEffect(() => {
        function handleResize(): void {
            setDimensions({
                height: window.innerHeight - (deductions?.height ?? 0),
                width: window.innerWidth - (deductions?.width ?? 0)
            })
        }

        window.addEventListener('resize', handleResize)

        return () => window.removeEventListener('resize', handleResize)
    }, [])

    return dimensions
}
